<script>
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  import auth from '../../api/auth'
  import { messages } from '../../data/messages'

  import ErrorBanner from '../components/ErrorBanner.svelte'
  import Input from '../components/Input.svelte'

  let error = null
  let isLoading = false

  let mail = ''
  let password = ''

  const PANEL_LOGIN = `${process.env.API_HOST}/panel/login`

  async function onSubmit() {
    if (isLoading) return
    if (!mail || !password) return

    isLoading = true
    error = null

    const response = await auth.getUser(mail, password)

    if (response.status === 'error') {
      error = {
        code: response.code,
        message: response.message
      }

      isLoading = false

      return
    }

    dispatch('login', { ...response.data, password })
  }

</script>

<p>Bitte loggen Sie sich ein.</p>

{#if error}
  <ErrorBanner content={error.message} />
{/if}

<form action="" on:submit|preventDefault={onSubmit} name="login">
  <Input
    label={'Mail'}
    name={'mail'}
    value={mail}
    on:update={(evt) => (mail = evt.detail)}
  />

  <Input
    label={'Passwort'}
    name={'password'}
    type="password"
    value={password}
    on:update={(evt) => (password = evt.detail)}
  />

  <a href={PANEL_LOGIN}>Passwort vergessen</a>

  <footer>
    <button type="submit">Submit</button>
  </footer>
</form>

<style>
  form {
    margin-top: 1rem;
  }

  footer {
    margin-top: 2rem;
  }

</style>
